import React from "react";
import { Div } from "components/Base";
import { noop } from "utils/General";
import styleSpects from "components/Base/Base/styleSpecs";

const MenuItem = ({
  leftIcon = "",
  rightIcon = "",
  children,
  onClick = noop
}) => (
  <Div
    fs={2}
    px={4}
    py={2}
    onClick={onClick}
    display="row.flex-start.center"
    bg={{
      hover: "neutral0",
      default: "white"
    }}
    color="gray7"
    height={48}
    style={{ cursor: "pointer" }}
  >
    {leftIcon ? (
      <Div display="row.flex-start.center" width={14} mr={2}>
        <i
          className={`material-icons-outlined ${leftIcon}`}
          style={{ color: "#494949", fontSize: styleSpects.fontSize[2] }}
        >
          {leftIcon}
        </i>
      </Div>
    ) : (
      <Div width={10} />
    )}
    {rightIcon ? (
      <Div display="row.space-between.center" flex={1}>
        {children}
        <i
          className="material-icons"
          style={{ color: "#494949", fontSize: styleSpects.fontSize[2] }}
        >
          {rightIcon}
        </i>
      </Div>
    ) : (
      children
    )}
  </Div>
);

export default MenuItem;
